import { Component, OnInit, ContentChild } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RepairshopCaseService } from '../../../api';
import { CustomdatepickerComponent } from '../../../../shared/modules/customdatepicker.component';

@Component({
  selector: 'app-return',
  templateUrl: './return.component.html',
  styleUrls: ['./return.component.scss']
})
export class ReturnComponent implements OnInit {
  @ContentChild(CustomdatepickerComponent) datepickerViewChild: CustomdatepickerComponent;

  today = new Date();
  minDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
  returnForm: FormGroup;
  return;
  data;
  status;

  constructor(
    public activeModal: NgbActiveModal,
    private rs: RepairshopCaseService
  ) { }

  ngOnInit() {
    const dt = new Date();
    const date = {
      'year': dt.getFullYear(),
      'month': dt.getMonth() + 1,
      'day': dt.getDate()
    };
    const time = {
      'hour': dt.getHours(),
      'minute': dt.getMinutes()
    };
    this.returnForm = new FormGroup({
      note: new FormControl(this.return ? this.return.returNote : ''),
      time: new FormControl(time),
      date: new FormControl(date),
      name: new FormControl(this.return ? this.return.receivedBy : '', [
        Validators.required
      ])
      
    });
    if (this.status === 'Closed' || this.status === 'Returned') {
      this.returnForm.disable();
    }
    console.log(this.return)
  }
  get name() { return this.returnForm.get('name'); }
  get note() { return this.returnForm.get('note'); }
  get time() { return this.returnForm.get('time'); }
  get date() { return this.returnForm.get('date'); }
  closeModal() {
    this.activeModal.dismiss('close');
  }
  saveModal() {
    const date = new Date(this.date.value.year, this.date.value.month, this.date.value.day,
      this.time.value.hour, this.time.value.minute);
    const data = {
      returnDate: Math.floor(date.getTime() / 1000),
      returnNote: this.note.value,
      receiver: this.name.value
    };
    this.activeModal.close(data);
  }
}
